import React, { useEffect, useState } from "react";
import axios from "axios";
import { getCurrentDate } from "../../Utilitie";

const IreUpdate = () => {
  const [rawdata, setRawdata] = useState([]);
  const [entry, setEntry] = useState([]);
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [startDate, setStartDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [endDate, setEndDate] = useState(new Date().toISOString().slice(0, 10));

  const keys = [
    "id",
    "DATE",
    "JUMBO_RECD",
    "JUMBO_IRE",
    "JUMBO_Y_DAY_O_B",
    "NBOX_RECD",
    "NBOX_IRE",
    "NBOX_Y_DAY_O_B",
    "BTPN_RECD",
    "BTPN_IRE",
    "BTPN_Y_DAY_O_B",
    "updated_by",
  ];

  const fetchData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefix}getDatewiseIREData?startDate=${startDate}&endDate=${endDate}`
      );

      if (response.data.status === "ok" && Array.isArray(response.data.data)) {
        const dataWithDefaults = response.data.data.map((item) => ({
          ...item,
          updated_by: item.updated_by,
        }));

        setRawdata(dataWithDefaults);
        setEntry(dataWithDefaults);
      } else {
        setRawdata([]);
        setEntry([]);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setError(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  useEffect(() => {
    const updatedData = entry.map((item) =>
      keys.reduce((acc, key) => {
        if (key === "updated_by") {
          acc[key] = item[key] || 3;
        } else {
          acc[key] = item[key] || "";
        }
        return acc;
      }, {})
    );
    setAllData(updatedData);
  }, [entry]);

  const handleChange = (rowIndex, key, value) => {
    const updatedEntries = [...entry];
    updatedEntries[rowIndex] = {
      ...updatedEntries[rowIndex],
      [key]: value,
    };
    setEntry(updatedEntries);
  };

  const handleSubmit = async () => {
    const finalData = allData.map((entry) => {
      const isoDate = new Date(entry.DATE).toISOString().slice(0, 10);
      return {
        ...entry,
        DATE: isoDate,
        updated_by: entry.updated_by,
        id: entry.id,
      };
    });

    try {
      const response = await axios.put(`${urlPrefix}update/ire`, finalData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      alert("Data updated successfully!");
    } catch (err) {
      console.error("Update error:", err.response?.data || err);
      alert("Update failed.");
    }
  };

  return (
    <div className=" papaDiv">
      <h5 className="mb-3 bg-dark text-white p-1 text-center fw-bold">
        Update IRE Data
      </h5>
      <div className="d-flex justify-content-center gap-3 mb-4 align-items-center bg-dark ">
        <label className="m-4 text-white fw-bolder">
          Start Date:{" "}
          <input
            type="date"
            max={endDate}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </label>
        <label className="m-4  text-white fw-bolder">
          End Date:{" "}
          <input
            type="date"
            min={startDate}
            value={endDate}
            max={getCurrentDate()}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </label>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-danger">Error loading data</p>
      ) : (
        <>
          <div className="table-responsive">
            <table className="table table-bordered table-striped mb-4">
              <thead className="table-dark text-center align-middle">
                <tr>
                  <th colSpan={2}></th>
                  <th colSpan={3}>JUMBO</th>
                  <th colSpan={3}>NBOX</th>
                  <th colSpan={3}>BTPN</th>
                </tr>
                <tr>
                  {keys.map(
                    (key, i) =>
                      key !== "updated_by" && (
                        <th key={i} style={{ minWidth: "90px" }}>
                          {key
                            .toUpperCase()
                            .replace("JUMBO_", " ")
                            .replace("NBOX_", " ")
                            .replace("BTPN_", " ")
                            .replace("RECD", "RECEIVED")
                            .replace("Y_DAY_O_B", "YESTERDAY O/B")}
                        </th>
                      )
                  )}
                </tr>
              </thead>
              <tbody>
                {entry.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {keys.map(
                      (key, colIndex) =>
                        key !== "updated_by" && (
                          <td key={colIndex}>
                            {key === "DATE" ? (
                              <input
                                type="date"
                                className="form-control"
                                style={{ fontSize: "0.8rem" }}
                                value={
                                  row[key]
                                    ? row[key].slice(0, 10)
                                    : new Date().toISOString().slice(0, 10)
                                }
                                onChange={(e) =>
                                  handleChange(rowIndex, key, e.target.value)
                                }
                              />
                            ) : key === "id" ? (
                              <div>{row[key]}</div>
                            ) : (
                              <input
                                type="number"
                                className="form-control"
                                style={{
                                  height: "26px",
                                  padding: "2px 6px",
                                  fontSize: "0.8rem",
                                }}
                                value={row[key] || ""}
                                onChange={(e) =>
                                  handleChange(rowIndex, key, e.target.value)
                                }
                              />
                            )}
                          </td>
                        )
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="text-center mt-4">
            <button
              className="btn btn-outline-success m-2 px-5"
              onClick={handleSubmit}
            >
              Update
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default IreUpdate;
